function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.414 16l12.293 12.293a1 1 0 1 1-1.414 1.414L8.646 17.061a1.5 1.5 0 0 1 0-2.122L21.293 2.293a1 1 0 1 1 1.414 1.414L10.414 16z"
});

var SvgCarouselLeft = function SvgCarouselLeft(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "f54890adbefad5753b711d48d3d27543.svg";
export { SvgCarouselLeft as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/carousel-left.svg
// module id = null
// module chunks = 